var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReject(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.199636 0.199636C0.327629 0.0718025 0.501128 0 0.682025 0C0.862921 0 1.03642 0.0718025 1.16441 0.199636L12.0864 11.1216C12.1535 11.1841 12.2073 11.2595 12.2446 11.3432C12.2819 11.427 12.302 11.5174 12.3036 11.609C12.3052 11.7007 12.2883 11.7917 12.254 11.8767C12.2197 11.9617 12.1686 12.0389 12.1037 12.1037C12.0389 12.1686 11.9617 12.2197 11.8767 12.254C11.7917 12.2883 11.7007 12.3052 11.609 12.3036C11.5174 12.302 11.427 12.2819 11.3432 12.2446C11.2595 12.2073 11.1841 12.1535 11.1216 12.0864L0.199636 1.16441C0.0718025 1.03642 0 0.862921 0 0.682025C0 0.501128 0.0718025 0.327629 0.199636 0.199636Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0861 0.199636C12.2139 0.327629 12.2857 0.501128 12.2857 0.682025C12.2857 0.862921 12.2139 1.03642 12.0861 1.16441L1.1641 12.0864C1.0347 12.207 0.863543 12.2726 0.686696 12.2695C0.50985 12.2664 0.341118 12.1948 0.21605 12.0697C0.0909807 11.9446 0.0193399 11.7759 0.0162196 11.599C0.0130994 11.4222 0.0787433 11.251 0.199322 11.1216L11.1213 0.199636C11.2493 0.0718025 11.4228 0 11.6037 0C11.7846 0 11.9581 0.0718025 12.0861 0.199636Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReject);
export default __webpack_public_path__ + "static/media/reject.960cf4f3031cd61e8644243fe91bf1e6.svg";
export { ForwardRef as ReactComponent };